exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-75e5d6b8]{position:relative}form .disable-overlay[data-v-75e5d6b8]{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:hsla(0,0%,100%,.9)}", ""]);

// exports
